import React from "react";

const IDUploadImagePopup = ({ show, onClose, imageSrc }) => {
  if (!show) return null;

  return (
    <div className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 popup">
      <div className="position-relative">
        <button
          onClick={onClose}
          className="btn-close position-absolute top-0 end-0 m-2 me-5"
          style={{
            zIndex: 2,
          }}
        />
        <div className="modal-body mx-1 mx-md-4">
          <img
            src={imageSrc}
            alt="Enlarged"
            className="img-fluid w-100 rounded"
            style={{
              maxHeight: "80vh",
              objectFit: "contain",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default IDUploadImagePopup;
